import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
//import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

//Tabs
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import _ from 'lodash';
//import FormText from "../form/FormText";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import calendarConfig from '../../libs/calendarConfig';
//import FormCheckbox from "../form/FormCheckbox";

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';
import FormComponent from '../FormComponent';
import SectionHeader from '../SectionHeader';
import FormDatePicker from '../form/FormDatePicker';
import UserAssignmentContainer from '../../containers/UserAssignment';
import { Badge, Box } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import ShiftSelect from '../advancedForm/ShiftSelect';
import FormTimePicker from '../form/FormTimePicker';
import UserScheduleTypeSelect from '../advancedForm/UserScheduleTypeSelect';
import Note from '../Note';

function TabPanel(props) {
	const { children } = props;

	return (
		<div style={{ paddingTop: 20, paddingLeft: 10, paddingRight: 10 }}>
			<Box>{children}</Box>
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 30,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		noNotes: {
			color: '#999',
			textTransform: 'italic',
		},
		dateNote: {
			color: '#666',
			fontSize: 14,
		},
		noteContainer: {
			paddingBottom: 5,
			borderBottom: '1px solid #f5f5f5',
			marginBottom: 5,
		},
		badgeMargin: {
			paddingRight: 10,
		},
		noteBadge: {
			backgroundColor: '#00BCD4',
		},
		activityBadge: {
			backgroundColor: '#9C27B0',
		},
		dialogRoot: {
			//overflow: 'visible'
			//alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		truckSection: {
			fontSize: '120%',
			display: 'flex',
			alignItems: 'space-between',
			marginTop: 10,
		},
		label: {
			paddingRight: 3,
		},
		value: {
			fontWeight: 700,
			color: '#555',
			paddingRight: 25,
		},
		shiftDot: {
			fontWeight: 700,
			color: '#555',
			borderRadius: '15px',
			width: 15,
			height: 15,
			display: 'inline-block',
			margin: 2,
			marginBottom: 6,
			verticalAlign: 'middle',
		},
	};
}

class UpdateUserAssignmentDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			selectedTabValue: 0,
			isSaving: false,
			savingSuccessful: false,
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { data } = this.props;

		if (data && data !== prevProps.data) {
			const { userAssignment } = data;

			console.log(userAssignment);
			this.setState({
				userId: '',

				locationId: userAssignment.locationId,
				shiftId: userAssignment.shiftId,

				shiftTime: moment(`2019-01-01 ${userAssignment.shiftTime}`).format('YYYY-MM-DD HH:mm'),
				userAssignmentTypeId: userAssignment.userAssignmentTypeId,

				startDate: moment().format('YYYY-MM-DD'),
				endDate: moment().format('YYYY-MM-DD'),
			});
		}
	}

	handleEndDriverAssignment = () => {
		const {
			data,
			showErrors,
			endUserAssignment,
			onRefreshData,
			//searchUserAssignments,
		} = this.props;

		const { userAssignment } = data;
		const { endDate } = this.state;

		const formFieldError = {};
		[{ path: 'endDate', label: 'End Date' }].forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({ isSaving: true, savingSuccessful: false });

		endUserAssignment({
			params: {
				userAssignmentId: userAssignment.userAssignmentId,
				endDate,
			},
			callback: (err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					onRefreshData();
					//searchUserAssignments();
					_.delay(() => {
						this.setState({ savingSuccessful: false });
					}, 2000);
				}, 400);
			},
		});
	};

	handleUpdate = () => {
		const { data, showErrors, updateUserAssignment, onRefreshData } = this.props;

		const { userAssignment } = data;

		const formFieldError = {};
		[
			{ path: 'shiftId', label: 'Shift' },
			{
				path: 'shiftTime',
				label: 'Shift Time',
			},
			{
				path: 'userAssignmentTypeId',
				label: 'Schedule Routine',
			},
		].forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({ isSaving: true, savingSuccessful: false });

		const { shiftId, shiftTime, userAssignmentTypeId } = this.state;
		updateUserAssignment({
			params: {
				userAssignmentId: userAssignment.userAssignmentId,
				shiftId,
				shiftTime: moment(shiftTime).format('HH:mm'),
				userAssignmentTypeId,
			},
			callback: (err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					onRefreshData();
					//searchUserAssignments();
					_.delay(() => {
						this.setState({ savingSuccessful: false });
					}, 2000);
				}, 400);
			},
		});
	};

	handleTabChange = (event, selectedTabValue) => {
		this.setState({ selectedTabValue });
	};

	handleChangeIndex = (index) => {
		this.setState({ index });
	};

	render() {
		const { open, onClose, data, classes } = this.props;

		const { selectedTabValue } = this.state;

		if (!data) {
			return null;
		}

		// TODO user
		const { user, userAssignment } = data;
		const { isSaving, savingSuccessful } = this.state;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>Update {user.firstName}'s Schedule</div>
						<div>
							<IconButton className={classes.closeButton} onClick={onClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<Tabs
						value={selectedTabValue}
						indicatorColor="primary"
						textColor="primary"
						onChange={this.handleTabChange}
						style={{ borderBottom: '1px solid #eee' }}
					>
						<Tab label="Update Shift" />

						<Tab
							label={
								<Badge
									className={classes.badgeMargin}
									color="primary"
									classes={{ colorPrimary: classes.activityBadge }}
								>
									End Assignment
								</Badge>
							}
						/>

						<Tab
							label={
								<Badge
									className={classes.badgeMargin}
									color="primary"
									classes={{ colorPrimary: classes.noteBadge }}
								>
									Move Location
								</Badge>
							}
						/>
					</Tabs>

					<SwipeableViews
						//axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
						index={selectedTabValue}
						onChangeIndex={this.handleChangeIndex}
					>
						<TabPanel value={selectedTabValue} index={0}>
							<Grid container spacing={2}>
								<ShiftSelect
									{...this.setForm('shiftId', 'Day / Night Shift', true)}
									gridProps={{ sm: 5 }}
								/>
								<Grid item sm={1} />
								<FormTimePicker
									{...this.setForm('shiftTime', 'Shift Time')}
									minutesStep={5}
									//format={'HH:mm'}
									gridProps={{ sm: 5 }}
								/>
								<UserScheduleTypeSelect
									{...this.setForm('userAssignmentTypeId', 'Driver Schedule Routine', true)}
									selectedLocationId={parseInt(userAssignment.locationId, 10)}
								/>

								<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
									<Button
										variant="contained"
										color="primary"
										className={classes.addButton}
										onClick={this.handleUpdate}
										disabled={isSaving}
									>
										Update Driver Schedule
									</Button>

									<Zoom
										in={isSaving}
										style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
										mountOnEnter
										unmountOnExit
									>
										<div className={classes.isSaving}>
											<CircularProgress style={{ verticalAlign: 'middle' }} />
											<span style={{ paddingLeft: 10 }}>Saving...</span>
										</div>
									</Zoom>

									<Zoom
										in={savingSuccessful}
										style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
									>
										<div className={classes.savingSuccessful}>
											<div className={classes.greenCheckedIcon} />
											<span style={{ paddingLeft: 10 }}>Save Successful.</span>
										</div>
									</Zoom>
								</Grid>
							</Grid>
						</TabPanel>

						<TabPanel value={selectedTabValue} index={2}>
							<Grid item xs={12}>
								<SectionHeader
									label={'When will driver be done with this assignment'}
									isTop={true}
								/>
							</Grid>

							<FormDatePicker {...this.setForm('endDate', 'End Date')} />

							<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleEndDriverAssignment}
									disabled={isSaving}
								>
									End Driver Assignment
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter
									unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{ verticalAlign: 'middle' }} />
										<span style={{ paddingLeft: 10 }}>Saving...</span>
									</div>
								</Zoom>

								<Zoom
									in={savingSuccessful}
									style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
								>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon} />
										<span style={{ paddingLeft: 10 }}>Save Successful.</span>
									</div>
								</Zoom>
							</Grid>
						</TabPanel>

						<TabPanel value={selectedTabValue} index={1}>
							<Grid container spacing={2}>
								<Note>
									To switch a driver to a new terminal, open that terminal in the schedule and click
									"Add Driver" and add them. This will end the driver's current assignment and start
									them at the new terminal.
								</Note>
							</Grid>
						</TabPanel>
					</SwipeableViews>
				</div>
			</Dialog>
		);
	}
}

UpdateUserAssignmentDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	data: PropTypes.object,
	endUserAssignment: PropTypes.func.isRequired,
	updateUserAssignment: PropTypes.func.isRequired,
	// userAssignment : PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	UserAssignmentContainer,
])(UpdateUserAssignmentDialog);
